<template>
  <div class="sidebar-inner">
    <div class="highlight-article">
      <span>
        <SvgImg name="highlight-write-article-bg" />
      </span>
      <figure>
        <img src="/assets/img/icons/highlight-add-article.svg" alt="icon-add-article" width="69" height="67" />
      </figure>
      <h3>Add Your Thoughts On This Beauty Platform</h3>
      <p>{{ copywriting }}</p>
      <a :href="buttonRedirectUrl" class="btn btn--black" @click.prevent="writeContent">{{ buttonText }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'add-thoughts',
  props: {
    buttonText: {
      required: true,
      type: String,
      default: 'Write Article',
    },
    buttonRedirectUrl: {
      required: true,
      type: String,
    },
    copywriting: {
      required: true,
      type: String,
      default: 'Ingin berkontribusi menambah artikel dengan konten yang menarik?',
    },
  },
  computed: {
    isLogin() {
      return this.$store.state.auth.userProfile;
    },
  },
  methods: {
    writeContent() {
      if (this.isLogin) {
        this.$router.push(this.buttonRedirectUrl);
      } else {
        this.$store.commit('setDataModal', {
          modalName: 'loginPage',
          value: 1,
        });
      }
    },
  },
};
</script>
